export default {"src":"/_next/static/media/Traumatic Brain Injury.355e8fa2.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};